import React from 'react';

import { useFormContext } from 'react-hook-form';

import { DateRangeFilter } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter';
import { TabOptions } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter.utils';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import { getInputValue } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.utils';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const StartDate = ({ isSelected, onFiltersChanged }) => {
    const { watch } = useFormContext<IFields>();
    const handleStartDateSelection = (data: { value?: string[] | string; type?: TabOptions }) => {
        if (data.type === 'FIXED_DATE') {
            const tempFlags = watch('flags');
            delete tempFlags.startDatesRange;
            onFiltersChanged({
                startDate: { value: Array.isArray(data.value) ? data.value.map(String) : [], type: data.type },
                flags: tempFlags,
            });
        } else {
            onFiltersChanged({
                startDate: { value: [], type: data.type },
                flags: {
                    ...watch('flags'),
                    startDatesRange: data.value as string,
                },
            });
        }
    };

    const startDateExistingData = {
        type: watch('startDate').type,
        value: watch('startDate').value.length === 0 ? watch('flags').startDatesRange : watch('startDate').value,
    };
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Start Date</span>
            <DateRangeFilter
                onChange={handleStartDateSelection}
                value={startDateExistingData}
                inputDefaultValue={getInputValue(startDateExistingData)}
            />
        </div>
    ) : null;
};
